export const isEmailValid = (email: string) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const getFormattedPhoneNumber = (
  fullNumber: string,
  countryCode: string,
) => {
  const strippedCountryCode = fullNumber.split(countryCode)[1];

  if (strippedCountryCode === "0") {
    return fullNumber;
  }

  const strippedNumber = strippedCountryCode?.replace(/([0]?)(.+)/, "$2") ?? "";

  return `${countryCode}${strippedNumber}`;
};
